export default [
  {name: 'MASCULINO', value: 'M'},
  {name: 'FEMENINO', value: 'F'},
]



// WEBPACK FOOTER //
// ./src/shared/routers/languages/es/arrays/sexes.js